// extracted by mini-css-extract-plugin
export default {"customConfirmBtn":"SharePopup_customConfirmBtn__XwLO8","cancelBtn":"SharePopup_cancelBtn__6uzsn"};